module.exports = __webpack_public_path__ + "static/spotify-7a34cf4279c6f8f8c97a1250ccce40a4.png";